import { VStack, Link, Box } from '@chakra-ui/react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { FiInfo, FiGlobe, FiKey } from 'react-icons/fi'

const SettingsSidebar = () => {
  const location = useLocation()
  
  const menuItems = [
    { 
      label: 'System Information', 
      path: '/settings/system',
      icon: FiInfo 
    },
    { 
      label: 'Locales', 
      path: '/settings/locales',
      icon: FiGlobe 
    },
    { 
      label: 'API Keys', 
      path: '/settings/api-keys',
      icon: FiKey 
    }
  ]

  return (
    <VStack spacing={2} align="stretch">
      {menuItems.map((item) => (
        <Link
          key={item.path}
          as={RouterLink}
          to={item.path}
          p={3}
          display="flex"
          alignItems="center"
          gap={3}
          borderRadius="md"
          bg={location.pathname === item.path ? 'blue.50' : 'transparent'}
          color={location.pathname === item.path ? 'blue.600' : 'gray.600'}
          _hover={{ bg: 'gray.50' }}
        >
          <Box as={item.icon} />
          {item.label}
        </Link>
      ))}
    </VStack>
  )
}

export default SettingsSidebar